import { newProperty } from "../schema.generator";

const schema = [
  { ...newProperty("height", "string", true, "Height") }
];

export default schema;
